module.exports = __webpack_public_path__ + "static/media/38.3240725c.jpg";